"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JourneySessionPage = void 0;
var React = require("react");
var react_router_1 = require("react-router");
var services_1 = require("@falcon/services");
var moment = require("moment");
var reactstrap_1 = require("reactstrap");
var core_1 = require("@athena-portal/core");
var JourneySessionPage = exports.JourneySessionPage = /** @class */ (function (_super) {
    __extends(JourneySessionPage, _super);
    function JourneySessionPage(props) {
        var _this = _super.call(this, props) || this;
        _this.lastUpdate = moment().utc();
        _this.state = {
            sessionInformation: {},
            // Check for session expiration every minute
            interval: 60000,
            showSessionWarning: false,
            showSessionExpired: false,
            warningNotClosedFirstTime: true,
            redirectOnSessionExpiration: false
        };
        _this.fetchSessionInformation = _this.fetchSessionInformation.bind(_this);
        _this.checkExpiryTimeOnIntervalChange = _this.checkExpiryTimeOnIntervalChange.bind(_this);
        _this.checkSessionInformation = _this.checkSessionInformation.bind(_this);
        _this.closeWarning = _this.closeWarning.bind(_this);
        _this.clearInterval = _this.clearInterval.bind(_this);
        _this.closeSessionExpiredModal = _this.closeSessionExpiredModal.bind(_this);
        _this.fetchSessionInformationAndCloseWarningModal = _this.fetchSessionInformationAndCloseWarningModal.bind(_this);
        _this.renderSessionAboutToTimeoutWarning = _this.renderSessionAboutToTimeoutWarning.bind(_this);
        _this.renderSessionTimeoutWarning = _this.renderSessionTimeoutWarning.bind(_this);
        _this.isNotAuthenticated = _this.isNotAuthenticated.bind(_this);
        return _this;
    }
    JourneySessionPage.getTimeInMinutes = function (calculateWarning) {
        var sessionDurationMilliseconds = process.env.REACT_APP_SESSION_DURATION_MILLISECONDS;
        var sessionWarningMilliseconds = process.env.REACT_APP_SESSION_WARNING_MILLISECONDS;
        if (sessionDurationMilliseconds && sessionWarningMilliseconds) {
            var sessionDurationMinutes = Math.floor(parseInt(sessionDurationMilliseconds, 10) / 60000);
            var sessionWarningMinutes = Math.floor(parseInt(sessionWarningMilliseconds, 10) / 60000);
            if (calculateWarning) {
                return (sessionDurationMinutes - sessionWarningMinutes).toString();
            }
            else {
                return (sessionDurationMinutes).toString();
            }
        }
        return "";
    };
    JourneySessionPage.prototype.componentDidMount = function () {
        if (this.isNotAuthenticated()) {
            this.fetchSessionInformation();
            this.checkExpiryTimeOnIntervalChange();
        }
    };
    JourneySessionPage.prototype.componentWillUnmount = function () {
        if (this.isNotAuthenticated()) {
            this.clearInterval();
        }
    };
    JourneySessionPage.prototype.componentDidUpdate = function (prevProps, prevState, snapshot) {
        if (this.isNotAuthenticated()) {
            var now = moment().utc();
            if (now.diff(this.lastUpdate, "seconds") >= 60) {
                this.fetchSessionInformation();
                this.lastUpdate = now;
            }
        }
    };
    JourneySessionPage.prototype.render = function () {
        if (this.isNotAuthenticated()) {
            return (React.createElement(React.Fragment, null,
                this.state.showSessionWarning && this.state.warningNotClosedFirstTime && this.renderSessionAboutToTimeoutWarning(),
                this.state.showSessionExpired && this.renderSessionTimeoutWarning(),
                this.state.redirectOnSessionExpiration && React.createElement(react_router_1.Redirect, { to: this.getJourneyStartPage() })));
        }
        return React.createElement(React.Fragment, null);
    };
    JourneySessionPage.prototype.getJourneyStartPage = function () {
        var rentersEnabled = process.env.REACT_APP_RENTERS_ENABLED ? JSON.parse(process.env.REACT_APP_RENTERS_ENABLED) : true;
        return rentersEnabled ? '/products' : services_1.productHelper.getNewBusinessUrl(services_1.ProductsEnum.MOTOR);
    };
    JourneySessionPage.prototype.renderSessionAboutToTimeoutWarning = function () {
        return (React.createElement(reactstrap_1.Modal, { isOpen: this.state.showSessionWarning, toggle: this.closeWarning, backdrop: "static" },
            React.createElement(reactstrap_1.ModalHeader, { toggle: this.closeWarning }, "Just to let you know"),
            React.createElement(reactstrap_1.ModalBody, null,
                React.createElement("p", null,
                    "Your session is about to timeout because it has been inactive for the last",
                    ' ',
                    React.createElement("b", null,
                        JourneySessionPage.getTimeInMinutes(true),
                        " minutes.")),
                React.createElement("br", null),
                React.createElement("p", null,
                    "Please press continue, don't worry, you'll get",
                    ' ',
                    React.createElement("b", null,
                        JourneySessionPage.getTimeInMinutes(false),
                        " minutes"),
                    " to complete each remaining page.")),
            React.createElement(reactstrap_1.ModalFooter, null,
                React.createElement(reactstrap_1.Button, { color: "btn btn-primary btn-next btn-wide", onClick: this.fetchSessionInformationAndCloseWarningModal }, "Continue"))));
    };
    JourneySessionPage.prototype.renderSessionTimeoutWarning = function () {
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Modal, { isOpen: this.state.showSessionExpired, toggle: this.closeSessionExpiredModal, backdrop: "static" },
                React.createElement(reactstrap_1.ModalHeader, { toggle: this.closeSessionExpiredModal }, "Sorry..."),
                React.createElement(reactstrap_1.ModalBody, null,
                    React.createElement("p", null,
                        "Unfortunately your session has timed out because you did not complete this page in",
                        ' ',
                        React.createElement("b", null,
                            JourneySessionPage.getTimeInMinutes(false),
                            " minutes.")),
                    React.createElement("br", null),
                    React.createElement("p", null, "To get a quote please close the window and start again.")))));
    };
    JourneySessionPage.prototype.fetchSessionInformation = function () {
        var _this = this;
        this.propositionEngine.fetchSessionInformation().subscribe(function (session) {
            if (session) {
                if (_this.props.pageContext.interaction.uistate !== undefined && _this.props.pageContext.interaction.uistate !== null) {
                    if (_this.props.pageContext.interaction.uistate.sessionEndDate !== undefined) {
                        _this.props.pageContext.interaction.uistate.sessionEndDate = session.expiryTime;
                    }
                }
                _this.setState({
                    sessionInformation: session,
                    warningNotClosedFirstTime: true,
                    redirectOnSessionExpiration: false
                });
            }
        });
    };
    JourneySessionPage.prototype.fetchSessionInformationAndCloseWarningModal = function () {
        this.fetchSessionInformation();
        this.setState({
            showSessionWarning: false
        });
    };
    JourneySessionPage.prototype.checkExpiryTimeOnIntervalChange = function () {
        var _this = this;
        this.timerID = window.setInterval(function () {
            _this.checkSessionInformation();
        }, this.state.interval);
    };
    JourneySessionPage.prototype.checkSessionInformation = function () {
        var expiryTime = moment(this.state.sessionInformation.expiryTime).utc();
        var nowInMoment = moment().utc();
        var expiryTimeShowModal = moment(expiryTime).subtract(5, "minutes").utc();
        if (nowInMoment.isSameOrAfter(expiryTimeShowModal)) {
            this.setState({
                showSessionWarning: true
            });
        }
        if (nowInMoment.isSameOrAfter(expiryTime)) {
            this.setState({
                showSessionWarning: false,
                showSessionExpired: true,
                warningNotClosedFirstTime: false
            });
            this.clearInterval();
        }
    };
    JourneySessionPage.prototype.closeSessionExpiredModal = function () {
        this.setState({
            showSessionExpired: false,
            redirectOnSessionExpiration: true
        });
        this.fetchSessionInformation();
        this.checkExpiryTimeOnIntervalChange();
    };
    JourneySessionPage.prototype.clearInterval = function () {
        clearInterval(this.timerID);
    };
    JourneySessionPage.prototype.closeWarning = function () {
        this.setState({
            showSessionWarning: !this.state.showSessionWarning,
            warningNotClosedFirstTime: false
        });
    };
    JourneySessionPage.prototype.isNotAuthenticated = function () {
        return this.applicationGuard && !this.applicationGuard.getUser();
    };
    __decorate([
        (0, core_1.lazyInject)(core_1.TypeDefs.ApplicationGuard),
        (0, core_1.optional)(),
        __metadata("design:type", Object)
    ], JourneySessionPage.prototype, "applicationGuard", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconPropositionEngine),
        __metadata("design:type", Object)
    ], JourneySessionPage.prototype, "propositionEngine", void 0);
    return JourneySessionPage;
}(React.Component));
//# sourceMappingURL=JourneySessionPage.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/pages/JourneySessionPage.js
// module id = 2545
// module chunks = 0